export const statusEnum = {
    ACCEPTED: 'accepted',
    PENDING: 'pending',
    DECLINED: 'declined'
}
